import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { HttpService } from "src/app/core/services/http-service";

@Injectable({ providedIn: "root" })
export class CorteSyncApiService extends HttpService {
  constructor(
    http: HttpClient,
    router: Router,
    toastService: ToastrService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    super(http, router, toastService, platformId);
  }

  /**
   * Sync completo (fonte única no backend).
   * Envia sempre o estado inteiro (modo "sync").
   */
  salvarItens(payload: any): Observable<any> {
    const url = `${Configuracoes.API}v2/pedido/itens`;
    return this.http.post(url, payload, this.getHttpOptions());
  }
}

